<ng-container *transloco="let tr; prefix:'compositeProducts'; scope: 'composite-products'">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header nzBackIcon [nzGhost]="false">
      <nz-page-header-title>{{'compositeProducts.title' | transloco}}</nz-page-header-title>
      <nz-page-header-subtitle>{{product.title | uiLabel}}</nz-page-header-subtitle>
    </nz-page-header>
  </nz-affix>

  <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Наименование</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Описание</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-label-edit formControlName="description"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Страна</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-country-select formControlName="countryId"></hx-country-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Тип</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-select formControlName="type" nzShowSearch nzAllowClear nzPlaceHolder="Выберите тип">
              <nz-option *ngFor="let op of compositeTypeOptions" [nzValue]="op.value" [nzLabel]="op.key | transloco"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">{{ 'compositeProducts.edit.section' | transloco }}</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24" [nzExtra]="(me.admin ? 'compositeProducts.edit.sectionHint' : 'compositeProducts.edit.sectionAdminOnly') | transloco">
            <nz-select formControlName="sectionId" nzAllowClear [nzPlaceHolder]="'compositeProducts.edit.sectionPlaceholder' | transloco">
              @for (option of sectionOptions; track option.id) {
                <nz-option [nzValue]="option.id" [nzLabel]="option.text"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">{{ 'compositeProducts.edit.slug' | transloco }}</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24" [nzExtra]="'compositeProducts.edit.slugHint' | transloco">
            <input nz-input readonly [value]="slug" [placeholder]="(isCreate ? 'compositeProducts.edit.slugAfterSave' : 'compositeProducts.edit.slugNone') | transloco"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>Цена</nz-form-label>
          <nz-form-control>
            <nz-input-number
              formControlName="price"
              [nzMin]="1"
              [nzMax]="10000000"
              [nzStep]="500"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>Порядок</nz-form-label>
          <nz-form-control>
            <nz-input-number
              formControlName="sortOrder"
              [nzMin]="1"
              [nzMax]="1000"
              [nzStep]="1"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>Продажа</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="sellable">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-form-item>
          <nz-form-label nzRequired>Онлайн</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="onlineSellable">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">{{ 'compositeProducts.column.tags' | transloco }}</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hc-label-select formControlName="tags"></hc-label-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider nzDashed="true" nzText="Продукты" nzOrientation="left"></nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col *ngFor="let subProduct of subProducts; let ix = index">
        <div class="ant-card ant-card-bordered hx-card">
          <div class="ant-card-body">
            <div class="ant-card-meta">
              <div class="ant-card-meta-detail">
                <div class="ant-card-meta-title">{{subProduct.title.ru}} / {{subProduct.title.kk}}</div>
                <div class="ant-card-meta-description">кол-во: {{subProduct.priceAmount}}, порядок: {{subProduct.sortOrder}}</div>
              </div>
            </div>
          </div>
          <ul class="ant-card-actions">
            <li>
              <button (click)="editSubProduct(subProduct, ix)" type="button" nzType="default" nz-button>
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button>
            </li>
            <li>
              <button type="button" nzDanger nzType="default" nz-button nz-popconfirm
                      [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                      [nzCancelText]="'no1' | transloco"
                      (nzOnConfirm)="deleteSubProduct(ix)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div nz-col class="cp_add-new-card">
        <button type="button" nzSize="large" nz-button nzType="dashed" (click)="addSubProduct()">
          <i nz-icon nzType="plus-circle" nzTheme="twotone"></i> Добавить продукт
        </button>
      </div>
    </div>

    <nz-form-item nz-row class="cp_actions">
      <nz-form-control [nzSpan]="14">
        <button type="submit" nz-button nzType="primary" [nzLoading]="isSaving" [disabled]="isSaving">
          <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
